interface NodeStatusBadgeProps {
  enabled: boolean;
}

export const NodeStatusBadge = ({ enabled }: NodeStatusBadgeProps) => {
  return (
    <span
      className={`text-xs px-2 py-1 rounded ${
        enabled
          ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
          : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400'
      }`}
    >
      {enabled ? 'Enabled' : 'Disabled'}
    </span>
  );
};
